//
// Standard symbol animations
//
// A symbols animation must have the following function
// - animate(x, y, symbolIndex, numSymbols, value, completeCallback)

pulseSymbolAnimation = {};

pulseSymbolAnimation.playAnimation = function(sequence, completeCallback) {
    pulseSymbolAnimation.animationsRemaining = sequence.data.length;
    pulseSymbolAnimation.completeCallback = completeCallback;
    pulseSymbolAnimation.sequence = sequence;

    if (checkForDefined(sequence.sound)) {
        soundManager.play(sequence.sound);
    }

    for (var i = 0; i < sequence.data.length; i++) {
        reelAnimationManager.animationStrips[sequence.data[i].reel].showAnimation(sequence.data[i].row, sequence.data[i].symbolIndex, 0, false);
        reelManager.reels[sequence.data[i].reel].showSymbol(sequence.data[i].row, false);
    }

    for (var i = 0; i < reelManager.reels.length; i++) {
        reelManager.reels[i].dimAllSymbols(true);
    }

    pulseSymbolAnimation.animationTime = 0;
    pulseSymbolAnimation.maxAnimationTime = 700;

    Reflex.addToUpdate(pulseSymbolAnimation.update);
};

pulseSymbolAnimation.skipAnimation = function() {
    pulseSymbolAnimation.animationTime = pulseSymbolAnimation.maxAnimationTime;

    if (checkForDefined(pulseSymbolAnimation.sequence.sound)) {
        soundManager.stop(pulseSymbolAnimation.sequence.sound);
    }

};

pulseSymbolAnimation.update = function(delta) {

    pulseSymbolAnimation.animationTime += delta;
    var seq = pulseSymbolAnimation.sequence;

    if (pulseSymbolAnimation.animationTime < pulseSymbolAnimation.maxAnimationTime) {
        var progress = pulseSymbolAnimation.animationTime / pulseSymbolAnimation.maxAnimationTime;
        var scale = 1 + Math.sin(Math.PI * 4 * progress) * (1-progress) * 0.25;

        for (var i = 0; i < seq.data.length; i++) {
            reelAnimationManager.animationStrips[seq.data[i].reel].reelAnimations[seq.data[i].row].scale.set(scale);
        }
    }
    else {
        // Hide animations and show original reel symbols
        for (var i = 0; i < seq.data.length; i++) {
            reelAnimationManager.animationStrips[seq.data[i].reel].hideAllAnimations();
            reelManager.reels[seq.data[i].reel].showSymbol(seq.data[i].row, true);
        }

        // Show all symbols again
        for (var i = 0; i < reelManager.reels.length; i++) {
            reelManager.reels[i].dimAllSymbols(false);
        }


        Reflex.removeFromUpdate(pulseSymbolAnimation.update);
        pulseSymbolAnimation.completeCallback();
    }
};


resourceManager.registerPlugIn("pulseSymbolAnimation", pulseSymbolAnimation);



movieSymbolAnimator = {};

movieSymbolAnimator.playAnimation = function(sequence, completeCallback) {

    movieSymbolAnimator.sequence = sequence;
    pulseSymbolAnimation.completeCallback = completeCallback;

    movieSymbolAnimator.soundFinished = true;
    if (typeof(sequence.sound) !== "undefined") {
        movieSymbolAnimator.soundFinished = false;
        soundManager.play(sequence.sound, movieSymbolAnimator.onSoundFinished);
    }

    // Hide reel symbols
    for (var i = 0; i < sequence.data.length; i++) {
        reelManager.reels[sequence.data[i].reel].showSymbol(sequence.data[i].row, false);
    }


    for (var i = 0; i < movieSymbolAnimator.sequence.data.length; i++) {
        for (j = 0; j < reelManager.reels[movieSymbolAnimator.sequence.data[i].reel].linkedAnimations.length; j++) {
            var animStrip = resourceManager.get(reelManager.reels[movieSymbolAnimator.sequence.data[i].reel].linkedAnimations[j].name);
            animStrip.showAnimation(movieSymbolAnimator.sequence.data[i].row, movieSymbolAnimator.sequence.data[i].symbolIndex);
        }
    }

    Reflex.addToUpdate(movieSymbolAnimator.update);
};

movieSymbolAnimator.skipAnimation = function() {
    if (checkForDefined(movieSymbolAnimator.sequence.sound)) {
        soundManager.stop(movieSymbolAnimator.sequence.sound)
    }

    movieSymbolAnimator.soundFinished = true;
    for (var i = 0; i < movieSymbolAnimator.sequence.data.length; i++) {
        for (j = 0; j < reelManager.reels[movieSymbolAnimator.sequence.data[i].reel].linkedAnimations.length; j++) {
            resourceManager.get(reelManager.reels[movieSymbolAnimator.sequence.data[i].reel].linkedAnimations[j].name).stopAnimation(movieSymbolAnimator.sequence.data[i].row);
        }
    }

};

movieSymbolAnimator.onSoundFinished = function() {
    movieSymbolAnimator.soundFinished = true;
};

movieSymbolAnimator.update = function() {
    if (movieSymbolAnimator.soundFinished) {
        // Check if all movie animations have completed
        if (movieSymbolAnimator.isAnimationComplete()) {
            // Animation complete
            Reflex.removeFromUpdate(movieSymbolAnimator.update);
            movieSymbolAnimator.clearAnimations();
            pulseSymbolAnimation.completeCallback();
        }
    }
};

movieSymbolAnimator.isAnimationComplete = function() {
    for (var i = 0; i < movieSymbolAnimator.sequence.data.length; i++) {
        for (j = 0; j < reelManager.reels[movieSymbolAnimator.sequence.data[i].reel].linkedAnimations.length; j++) {
            if ( resourceManager.get(reelManager.reels[movieSymbolAnimator.sequence.data[i].reel].linkedAnimations[j].name).isAnimationPlaying(movieSymbolAnimator.sequence.data[i].row) ) {
                return false;
            }
        }
    }

    return true;
};

movieSymbolAnimator.clearAnimations = function() {
    for (var i = 0; i < movieSymbolAnimator.sequence.data.length; i++) {
        for (j = 0; j < reelManager.reels[movieSymbolAnimator.sequence.data[i].reel].linkedAnimations.length; j++) {
            var animStrip = resourceManager.get(reelManager.reels[movieSymbolAnimator.sequence.data[i].reel].linkedAnimations[j].name);
            animStrip.hideAllAnimations();
        }
    }

    // Show reel symbols
    for (var i = 0; i < movieSymbolAnimator.sequence.data.length; i++) {
        reelManager.reels[movieSymbolAnimator.sequence.data[i].reel].showSymbol(movieSymbolAnimator.sequence.data[i].row, true);
    }

};


resourceManager.registerPlugIn("movieSymbolAnimator", movieSymbolAnimator);